import { CoreIcon } from '../core-icon';
import bankMastercardSquareSVG from '../../assets/logos/bank-mastercard-square.svg';
import type { IconProps } from '../core-icon';

export const BankMastercardSquareIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankMastercardSquareSVG} {...props} />;
};
